import { useTranslation } from 'react-i18next'

import { useDateLocale } from '../../../../hooks'
import Button from '../../../Button'
import { formatCalendarDate } from '../../Calendar.utils'

import { QA_NAME_CALENDAR_FOLLOW_UP_CAP_NEXT_FREE_DAY } from './NextFreeDayButton.constants'

function NextFreeDayButton({ date, isLoading, isSkeleton, onClick }) {
  const { t } = useTranslation()

  const locale = useDateLocale()

  return date ? (
    <Button.Outlined
      isLoading={isLoading}
      isSkeleton={isSkeleton}
      qaName={QA_NAME_CALENDAR_FOLLOW_UP_CAP_NEXT_FREE_DAY}
      text={t('Calendar.CapMoveToDateKey', {
        date: formatCalendarDate({ date, locale }),
      })}
      onClick={onClick}
    />
  ) : null
}

export default NextFreeDayButton
